<template>
	<span :class="ctx.state.sidebarTab == 'ai' ? 'selected' : ''" @click="ctx.state.selectTab('ai')" data-cy="tab-ai">
		<mdi robot-outline />
	</span>
</template>

<script>
// The sidebar tab that opens the AI chat. Pairs with Panel.vue, which renders the
// body for the same tab id.
import { aiSelector } from './selector'

export const extension = {
	...aiSelector,
	type: 'EntryEditor',
	location: 'tab',
}

export default {
	name: 'AiTab',
	props: { ctx: Object },
}
</script>
